/* istanbul ignore file */
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { ArtifactUploaderInput, ArtifactUploaderInputProps } from 'domain/shared/artifact/input';

const ContractScanUploaderInput = (props: ArtifactUploaderInputProps) => {
  return <ArtifactUploaderInput {...props} artifactTypeId={ARTIFACT_ID.CONTRACT_SCAN} />;
};

export default ContractScanUploaderInput;
